﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_messageWithName from './tpl/messageWithName.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';

import * as Entities_Empty from '../../../lib/entities/empty';
import View_DialogBoxInactive from '../../../lib/views/dialogBoxInactive/dialogBoxInactive';

export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_messageWithName({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;

        this.model.attributes.Header = resources[this.model.attributes.HeaderNumber];
        var title = resources[this.model.attributes.TitleNumber];
        this.model.attributes.Title = String.format(title, this.model.attributes.Name);
    },
    onBeforeShow: function () {
    },
    ui: {
    },
    events: {
    },
    onRender: function () {
    },
    onAttach(){
        if (this.model.attributes.Inactive == "true" || this.model.attributes.Inactive == true) {
            var dialogBoxInactiveModel = new Entities_Empty.Model();
            dialogBoxInactiveModel.attributes.Text = resources.X200201;
            var dialogBoxInactive = new View_DialogBoxInactive({ model: dialogBoxInactiveModel, parent: self });
            self.app.dialogRegion.show(dialogBoxInactive);
        }
    },
    onDestroy(){
    }
}, Backbone.Radio.Requests);
